<template>
    <div class="stat-card">
        <div class="stat-val" :class="valueClass">{{ value }}</div>
        <div class="stat-label">{{ label }}</div>
        <div v-if="delta" class="stat-delta" :class="deltaState">
            <span v-if="deltaArrow" class="stat-arrow">{{ deltaArrow }}</span>{{ delta }}
        </div>
    </div>
</template>

<script>
export default {
    name: "HomeStatCard",
    props: {
        value: {
            type: [String, Number],
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        delta: {
            type: String,
            default: '',
        },
        deltaState: {
            type: String,
            default: 'neutral',
        },
        valueClass: {
            type: String,
            default: '',
        },
    },
    computed: {
        deltaArrow(vm = this) {
            if (vm.deltaState === 'up') return '↑ '
            if (vm.deltaState === 'down') return '↓ '
            return ''
        },
    },
}
</script>

<style scoped>
.stat-card {
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 12px;
    padding: 14px 14px 12px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}

.stat-val {
    font-size: 28px;
    font-weight: 800;
    color: var(--v-txtPrimary-base);
    line-height: 1;
}

.stat-val.teal-color {
    color: var(--v-accent-base);
}

.stat-val.green-color {
    color: var(--v-success-base);
}

.stat-val.gradient {
    color: var(--v-accent-base);
}

.theme--dark .stat-val.gradient {
    color: var(--v-primary-base);
}

.stat-label {
    font-size: 11px;
    font-weight: 600;
    color: var(--v-txtMuted-base);
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.stat-delta {
    font-size: 11px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 3px;
}

.stat-delta.up {
    color: var(--v-success-base);
}

.stat-delta.down {
    color: var(--v-error-base);
}

.stat-delta.neutral {
    color: var(--v-txtMuted-base);
}

@media (max-width: 599px) {
    .stat-val {
        font-size: 22px;
    }
}
</style>
